import _defineProperty from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["axis"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { supportsScrollTimeline } from '../../../../../../motion-dom/dist/es/utils/supports/scroll-timeline.mjs';
import '../../../../../../motion-utils/dist/es/errors.mjs';
import { noop } from '../../../../../../motion-utils/dist/es/noop.mjs';
import { observeTimeline } from './observe.mjs';
import { scrollInfo } from './track.mjs';
function scrollTimelineFallback(_ref) {
  var source = _ref.source,
    container = _ref.container,
    _ref$axis = _ref.axis,
    axis = _ref$axis === void 0 ? "y" : _ref$axis;
  // Support legacy source argument. Deprecate later.
  if (source) container = source;
  // ScrollTimeline records progress as a percentage CSSUnitValue
  var currentTime = {
    value: 0
  };
  var cancel = scrollInfo(function (info) {
    currentTime.value = info[axis].progress * 100;
  }, {
    container: container,
    axis: axis
  });
  return {
    currentTime: currentTime,
    cancel: cancel
  };
}
var timelineCache = new Map();
function getTimeline() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    source = _ref2.source,
    _ref2$container = _ref2.container,
    container = _ref2$container === void 0 ? document.documentElement : _ref2$container,
    _ref2$axis = _ref2.axis,
    axis = _ref2$axis === void 0 ? "y" : _ref2$axis;
  // Support legacy source argument. Deprecate later.
  if (source) container = source;
  if (!timelineCache.has(container)) {
    timelineCache.set(container, {});
  }
  var elementCache = timelineCache.get(container);
  if (!elementCache[axis]) {
    elementCache[axis] = supportsScrollTimeline() ? new ScrollTimeline({
      source: container,
      axis: axis
    }) : scrollTimelineFallback({
      source: container,
      axis: axis
    });
  }
  return elementCache[axis];
}
/**
 * If the onScroll function has two arguments, it's expecting
 * more specific information about the scroll from scrollInfo.
 */
function isOnScrollWithInfo(onScroll) {
  return onScroll.length === 2;
}
/**
 * Currently, we only support element tracking with `scrollInfo`, though in
 * the future we can also offer ViewTimeline support.
 */
function needsElementTracking(options) {
  return options && (options.target || options.offset);
}
function scrollFunction(onScroll, options) {
  if (isOnScrollWithInfo(onScroll) || needsElementTracking(options)) {
    return scrollInfo(function (info) {
      onScroll(info[options.axis].progress, info);
    }, options);
  } else {
    return observeTimeline(onScroll, getTimeline(options));
  }
}
function scrollAnimation(animation, options) {
  animation.flatten();
  if (needsElementTracking(options)) {
    animation.pause();
    return scrollInfo(function (info) {
      animation.time = animation.duration * info[options.axis].progress;
    }, options);
  } else {
    var timeline = getTimeline(options);
    if (animation.attachTimeline) {
      return animation.attachTimeline(timeline, function (valueAnimation) {
        valueAnimation.pause();
        return observeTimeline(function (progress) {
          valueAnimation.time = valueAnimation.duration * progress;
        }, timeline);
      });
    } else {
      return noop;
    }
  }
}
function scroll(onScroll) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$axis = _ref3.axis,
    axis = _ref3$axis === void 0 ? "y" : _ref3$axis,
    options = _objectWithoutProperties(_ref3, _excluded);
  var optionsWithDefaults = _objectSpread({
    axis: axis
  }, options);
  return typeof onScroll === "function" ? scrollFunction(onScroll, optionsWithDefaults) : scrollAnimation(onScroll, optionsWithDefaults);
}
export { scroll };